import * as types from '../mutation-types'

// state
export const state = {
    layout: false,
    loading: null,
    toggleStatus: true
}

// getters
export const getters = {
    layout: state => state.layout,
    loading: state => state.loading,
    toggleStatus: state => state.toggleStatus
}

// mutations
export const mutations = {
  [types.SET_LAYOUT] (state, newLayout) {
    state.layout = !newLayout || newLayout == '' ? 'main-layout' : newLayout
  },
  [types.SET_LOADING] (state, newLoading) {
    state.loading = newLoading
  },
  [types.TOGGLE_BAR] (state) {
    state.toggleStatus = !state.toggleStatus
  }
}

// actions
export const actions = {
  setToggleBar ({ commit }) {
    commit(types.TOGGLE_BAR)
  },
}

